const config = {
  aws_cognito_identity_pool_id:
    process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,
  aws_cognito_region: process.env.REACT_APP_AWS_COGNITO_REGION,
  aws_user_pools_id: process.env.REACT_APP_AWS_USER_POOLS_ID,
  aws_user_pools_web_client_id:
    process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID,
  oauth: {
    domain: process.env.REACT_APP_AWS_OAUTH_DOMAIN,
    scope: ["email", "openid", "aws.cognito.signin.user.admin"],
    redirectSignIn: process.env.REACT_APP_AWS_OAUTH_REDIRECTSIGNIN,
    redirectSignOut: process.env.REACT_APP_AWS_OAUTH_REDIRECTSIGNOUT,
    responseType: "code",
  },
  federationTarget: "COGNITO_USER_POOLS",
};

if (window.location.hostname === "localhost") {
  config.oauth.redirectSignIn =
    process.env.REACT_APP_AWS_OAUTH_REDIRECTSIGNIN_LOCALHOST;
  config.oauth.redirectSignOut =
    process.env.REACT_APP_AWS_OAUTH_REDIRECTSIGNOUT_LOCALHOST;
}

export default config;
